import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { styles as brandColors } from "@superwall-me/tailwind-config";
import tw from "tailwind-styled-components";
import BaseContainer from "./BaseContainer";
const Container = tw(BaseContainer)`
  ${(p)=>{
    switch(p.$size){
        case "sm":
            return "w-[10px] h-[10px]";
        case "lg":
            return "w-[16px] h-[16px]";
        case "md":
        default:
            return "w-[14px] h-[14px]";
    }
}}

`;
const DIRECTION = {
    up: "rotate(180deg)",
    right: "rotate(-90deg)",
    left: "rotate(90deg)",
    down: "rotate(0deg)"
};
const Chevron = ({ color = "white", direction = "down", size })=>{
    return /*#__PURE__*/ _jsx(Container, {
        $size: size,
        style: {
            transform: DIRECTION[direction]
        },
        children: /*#__PURE__*/ _jsx("svg", {
            width: "13",
            height: "8",
            viewBox: "0 0 13 8",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M7.70696 7.70702L12.707 2.70702C12.8891 2.51842 12.9899 2.26582 12.9876 2.00362C12.9854 1.74142 12.8802 1.49061 12.6948 1.3052C12.5094 1.11979 12.2586 1.01462 11.9964 1.01235C11.7342 1.01007 11.4816 1.11086 11.293 1.29302L6.99996 5.58602L2.70696 1.29302C2.61471 1.19751 2.50437 1.12133 2.38236 1.06892C2.26036 1.01651 2.12914 0.988923 1.99636 0.987769C1.86358 0.986615 1.7319 1.01192 1.609 1.0622C1.48611 1.11248 1.37446 1.18673 1.28056 1.28062C1.18667 1.37452 1.11242 1.48617 1.06214 1.60907C1.01186 1.73196 0.986554 1.86364 0.987708 1.99642C0.988862 2.1292 1.01645 2.26042 1.06886 2.38242C1.12127 2.50443 1.19745 2.61477 1.29296 2.70702L6.29296 7.70702C6.48049 7.89449 6.73479 7.99981 6.99996 7.99981C7.26512 7.99981 7.51943 7.89449 7.70696 7.70702Z",
                fill: brandColors[color]
            })
        })
    });
};
export default Chevron;
